import React from "react";
import { useHistory } from "@iventis/subscriptions";
import { useDispatch } from "react-redux";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { Node } from "@iventis/domain-model/model/node";
import { Map } from "@iventis/domain-model/model/map";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { SocketEvent } from "@iventis/types/loading.types";
import { dataTestIds } from "@iventis/testing";
import { findNodesByType } from "@iventis/tree-browser";
import { CustomDialog } from "@iventis/components";
import { incrementMonitoringCount } from "@iventis/observability-and-monitoring";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { RootDispatch, SliceNames, resetSlice } from "../state/root.store";
import { createMapRequest } from "../state/map.slice.thunks";
import { mapCheckIfWaitingForByEventName, navigateToMap } from "../map.helpers";
import { CreateNodeComponent } from "./create-node";

export const CreateMapComponent: React.FC<{ open: boolean; close: () => void; parentId: string; tree: Node }> = ({ open, close, parentId, tree }) => {
    const translate = useIventisTranslate();

    const history = useHistory();
    const dispatch: RootDispatch = useDispatch();

    const createMapAndNavigate = async (node: Node) => {
        dispatch(resetSlice(SliceNames.MAP));
        if (!mapCheckIfWaitingForByEventName(SocketEvent.MAP_CREATED)) {
            // If a node of type MappingLibrary exists in the tree, we know that this map must be a shared map (Team map)
            const shared = findNodesByType([tree], NodeType.MappingLibrary)?.length > 0;
            const res = await dispatch(createMapRequest({ parentId: node.parentId, name: node.name, shared }));
            const payload = res.payload as Map;
            incrementMonitoringCount({ name: MetricName.PLAN_CREATED, resourceId: payload.id });
            navigateToMap(payload.id, node.parentId, history);
        }
        return Promise.resolve();
    };

    return (
        <CustomDialog maxWidth="sm" open={open} fullWidth onClose={() => close()} data-testid={dataTestIds.modals.createMap}>
            {open && (
                <CreateNodeComponent
                    parentId={parentId}
                    onClose={() => close()}
                    onConfirm={createMapAndNavigate}
                    nodeTypeToCreate={NodeType.Map}
                    title={translate(Content.library.create_node.title, { nodeName: translate(Content.library.node_names.Map) })}
                    fieldLabel={translate(Content.library.create_node.fieldLabel, { nodeName: translate(Content.library.node_names.Map) })}
                    tree={tree}
                />
            )}
        </CustomDialog>
    );
};
